import { toError } from '../tpa/common/error';
import { hasMultilineAddress } from './has-multiline-address';
import { hasPaymentField } from './has-payment-fields';
import { hasPhone } from './has-phone';
import { FIELD_TRANSLATION_LOADERS, LOCALE_DATASET_TRANSLATION_LOADERS, VIEWER_TRANSLATION_LOADERS } from './translation-loaders';
export const loadTranslations = importWithFallback(importTranslations);
const COUNTRY_KEYS_PREFIX = [
    'locale-dataset.countries'
];
const ADDRESS_KEYS_PREFIX = [
    'locale-dataset.states',
    'locale-dataset.subdivisions',
    'locale-dataset.addressParts'
];
const CURRENCY_KEYS_PREFIX = [
    'locale-dataset.currencies'
];
export const defaultLocaleDatasetLoader = (forms, language, errorMonitor)=>{
    const _hasPhone = forms.some(hasPhone);
    const _hasMultilineAddress = forms.some((f)=>hasMultilineAddress(f));
    const _hasPaymentField = forms.some(hasPaymentField);
    return ()=>loadLocaleDataset({
            language,
            errorMonitor,
            loadCountryKeys: _hasPhone || _hasMultilineAddress,
            loadAddressKeys: _hasMultilineAddress,
            loadCurrencyKeys: _hasPaymentField
        });
};
const loadLocaleDataset = async ({ language, errorMonitor, loadCountryKeys = false, loadAddressKeys = false, loadCurrencyKeys = false })=>{
    if (!loadCountryKeys && !loadAddressKeys) {
        return {};
    }
    const localeDataset = await importWithFallback(importLocaleDataset)(language, errorMonitor);
    const filteredDataset = {};
    for(const key in localeDataset){
        if (loadAddressKeys && ADDRESS_KEYS_PREFIX.some((prefix)=>key.startsWith(prefix))) {
            filteredDataset[key] = localeDataset[key];
        }
        if (loadCountryKeys && COUNTRY_KEYS_PREFIX.some((prefix)=>key.startsWith(prefix))) {
            filteredDataset[key] = localeDataset[key];
        }
        if (loadCurrencyKeys && CURRENCY_KEYS_PREFIX.some((prefix)=>key.startsWith(prefix))) {
            filteredDataset[key] = localeDataset[key];
        }
    }
    return filteredDataset;
};
// A templated `import()` of a bare module is not statically analyzable; the enumerated
// maps are what let a bundler emit a chunk per locale.
const load = async (loaders, locale)=>{
    const loader = loaders[locale];
    if (!loader) {
        throw new Error(`No translations bundled for language "${locale}"`);
    }
    return (await loader()).default;
};
async function importTranslations(locale) {
    const messages = await load(VIEWER_TRANSLATION_LOADERS, locale);
    const fieldMessages = await load(FIELD_TRANSLATION_LOADERS, locale);
    return {
        ...messages,
        ...fieldMessages
    };
}
async function importLocaleDataset(locale) {
    return load(LOCALE_DATASET_TRANSLATION_LOADERS, locale);
}
function importWithFallback(importMessages) {
    return async (locale, errorMonitor)=>{
        locale = locale ?? 'en';
        const baseLocale = locale.includes('-') ? locale.split('-')[0] : locale;
        try {
            return await importMessages(baseLocale);
        } catch (_error) {
            try {
                const messages = await importMessages('en');
                errorMonitor?.captureException(toError(_error));
                return messages;
            } catch (_error2) {
                errorMonitor?.captureException(toError(_error2));
                return {};
            }
        }
    };
}

//# sourceMappingURL=load-translations.js.map